import React from 'react'

const DivLoader = ({ isLoading, children }) => {
    return (
        <>
            {isLoading ? (
                <div className="loader-overlay">
                    <section className="ball-dots-container ui-page-loader">
                        <div className="ball-dot ui-page-loader__dot"></div>
                        <div className="ball-dot ui-page-loader__dot"></div>
                        <div className="ball-dot ui-page-loader__dot"></div>
                        <div className="ball-dot ui-page-loader__dot"></div>
                        <div className="ball-dot ui-page-loader__dot"></div>
                    </section>
                </div>
            ) : (
                children
            )}
        </>
    );
}

export default DivLoader
